import React from 'react';
import Landing_Section3_Img_1 from '../../images/shopify-popup/landing-section-3-img-1.png'
import Landing_Section3_Img_2 from '../../images/shopify-popup/landing-section-3-img-2.png'
import Landing_Section3_Img_3 from '../../images/shopify-popup/landing-section-3-img-3.png'
import Landing_Section3_Img_4 from '../../images/shopify-popup/landing-section-3-img-4.png'
import Landing_Section3_Img_5 from '../../images/shopify-popup/landing-section-3-img-5.png'
import Landing_Section3_Img_6 from '../../images/shopify-popup/landing-section-3-img-6.png'

class SectionThree extends React.Component {
  render() {
    return (
      <div className="main-container">
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Bussines Objectives</h2>
                <div
                  className=""
                  data-arrows="false"
                  data-paging="true"
                  data-children="6"
                >
                  <ul className="flickity-enabled is-draggable" tabIndex="0">
                    <div className="flickity-viewport">
                      <div>
                        <div className="row">
                          <li className="col-md-4">
                            <div className="feature feature-3 boxed boxed--lg boxed--border text-center">
                              <i className="icon">
                                <img
                                  className="shopify-popup-image"
                                  src={Landing_Section3_Img_1}
                                  alt="Image"
                                />
                              </i>
                              <h4>Collect Email Submissions</h4>
                              <p>
                              Generate email leads and enhance your email lists. Share targeted content and hit the 
                              bull’s eye with email marketing. 
                              </p>
                              <a
                                id="landing--learn-more--our-products-box1--link"
                                href="#"
                              >
                                Learn More
                              </a>
                            </div>
                          </li>
                          <li className="col-md-4">
                            <div className="feature feature-3 boxed boxed--lg boxed--border text-center">
                              <i className="icon">
                                <img
                                  className="shopify-popup-image"
                                  src={Landing_Section3_Img_2}
                                  alt="Image"
                                />
                              </i>
                              <h4>Inform The Visitors</h4>
                              <p>
                              Keep your visitors informed of new products, campaigns,
                               and updates. Give them opportunities to be your customers.
                              </p>
                              <a
                                id="landing--learn-more--our-products-box2--link"
                                href="#"
                              >
                                Learn More
                              </a>
                            </div>
                          </li>
                          <li className="col-md-4">
                            <div className="feature feature-3 boxed boxed--lg boxed--border text-center">
                              <i className="icon">
                                <img
                                  className="shopify-popup-image"
                                  src={Landing_Section3_Img_3}
                                  alt="Image"
                                />
                              </i>
                              <h4>Take Permissions</h4>
                              <p>
                              Request acceptance for requirements such as cookies or privacy policy. 
                              Ensure a browsing experience on a solid basis.
                              </p>
                              <a
                                id="landing--learn-more--our-products-box3--link"
                                href="#"
                              >
                                Learn More
                              </a>
                            </div>
                          </li>
                          <li className="col-md-4">
                            <div className="feature feature-3 boxed boxed--lg boxed--border text-center">
                              <i className="icon">
                                <img
                                  className="shopify-popup-image"
                                  src={Landing_Section3_Img_4}
                                  alt="Image"
                                />
                              </i>
                              <h4>Create Quick Surveys</h4>
                              <p>
                              Ask your visitors why they have not completed the purchase with an exit-intent popup survey. 
                              Get to the crux of the problem.
                              </p>
                              <a
                                id="landing--learn-more--our-products-box4--link"
                                href="#"
                              >
                                Learn More
                              </a>
                            </div>
                          </li>
                          <li className="col-md-4">
                            <div className="feature feature-3 boxed boxed--lg boxed--border text-center">
                              <i className="icon">
                                <img
                                  className="shopify-popup-image"
                                  src={Landing_Section3_Img_5}
                                  alt="Image"
                                />
                              </i>
                              <h4>Go Deep into Marketing</h4>
                              <p>
                               Use a wide range of marketing strategies to get your visitors to take the desired action.
                               Lead them professionally.
                              </p>
                              <a
                                id="landing--learn-more--our-products-box5--link"
                                href="#"
                              >
                                Learn More
                              </a>
                            </div>
                          </li>
                          <li className="col-md-4">
                            <div className="feature feature-3 boxed boxed--lg boxed--border text-center ">
                              <i className="icon">
                                <img
                                  className="shopify-popup-image"
                                  src={Landing_Section3_Img_6}
                                  alt="Image"
                                />
                              </i>
                              <h4>Segment Your Customers</h4>
                              <p>
                              Gather personal information from your visitors and create targeted campaigns easily with pinpoint accuracy.
                              </p>
                              <a
                                id="landing--learn-more--our-products-box6--link"
                                href="#"
                              >
                                Learn More
                              </a>
                            </div>
                          </li>
                        </div>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default SectionThree;